export const withToken = (url: string, token: string) =>
  `${url}?token=${encodeURIComponent(token)}`;
